import APINamespace from './namespace';

export default class APIBase {
  constructor(ctx) {
    this.ctx = ctx;
    this.modules = {};

    this.requestHooks = {};
    this.responseHooks = {};
  }

  /**
   * Register new API namespace
   * @param {string} name
   * @param {string} baseURL
   * @param {function[]} handlers
   */
  register(name, baseURL, handlers) {
    this.modules[name] = new APINamespace(this.ctx.$axios, baseURL, handlers);
  }

  /**
   * Dispatch API call
   * @param {*} name - namespace and method e.g "auth/login"
   * @param  {...any} args - any arguments accepted by handler
   */
  async dispatch(name, ...args) {
    const [key, handler] = name.split('/');
    const fn = this.modules[key] && this.modules[key].handlers[handler];

    if (this.requestHooks[name]) {
      this.requestHooks[name].forEach(hook => {
        try {
          hook(...args);
        } catch (e) {}
      });
    }

    if (typeof fn === 'function') {
      const response = await fn(...args);

      if (this.responseHooks[name]) {
        this.responseHooks[name].forEach(hook => {
          try {
            hook(response);
          } catch (e) {}
        });
      }

      return response;
    }

    throw new Error(`[API] unknown type: ${name}`);
  }

  /**
   * Add request hook to be executed during request lifecycle
   * IMPORTANT: this is an internal method, do not use it outside of this file
   * @param {string} name - handler to attach the hook to
   * @param {function} cb - callback function
   * @param {"requestHooks" | "responseHooks"} type - lifecycle hook
   */
  addHook(name, cb, type) {
    if (typeof cb === 'function') {
      this[type][name] = this[type][name] || [];
      this[type][name].push(cb);
    }
  }

  /**
   * Add callback before request is sent
   * @param {string} name - handler name to listen for
   * @param {function(...any)} cb - callback function receiving same args as handler
   */
  onRequest(name, cb) {
    this.addHook(name, cb, 'requestHooks');
  }

  /**
   * Add callback after response is received
   * @param {string} name - handler name to listen for
   * @param {function(object)} cb - callback function receiving same API response that handler returns
   */
  onResponse(name, cb) {
    this.addHook(name, cb, 'responseHooks');
  }
}
